const getLocale = locale => {
    if (!locale) {
        return 'en';
    }
    switch (locale) {
        case 'es-ES':
            return 'es';
        case 'de-DE':
            return 'de';
        case 'in':
            return 'id';
        case 'en-IN':
        case 'en-US':
        case 'en-GB':
            return 'en';
        default:
            return locale;
    }
};

export default getLocale;
